export default __webpack_public_path__ + "static/media/AVAX.234db155.svg";